import React from "react";
import { Field } from "redux-form";

const formatValue = value => {
  if (!value) {
    return "";
  }

  const strin = value.split("");
  for (let i = 0; i < strin.length; i += 1) {
    if (i === 6) {
      strin[i] = strin[i].substring(0, 2).toLowerCase();
    } else if (i === 1) {
      strin[i] = strin[i].toUpperCase();
    }
  }
  return strin.join("");
};

export default function ECCNField(props) {
  const { ...rest } = props;

  return <Field type="text" format={formatValue} {...rest} />;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/ECCNField/ECCNField.jsx